import AdminDashboard from "./Dashboard"
import { RefundCheck, PaymentTable, AdminPassKeys, ClosedTenders, OpenTenders, RefundFiles } from './Master/index'
import { CreateDepartment, CreateEmployee, CreateRoles, EditRoles, EditViewEmp } from './EMP Management/index'
import { CustomMisReport, MISActiveReport } from './MIS/index'
import { AuctionRefund, GenerateRefund, TenderWinnerRefund, TenderCancelRefund, GenerateTenderCancelRefund } from './Refund/index'
import { CreateAuction, ShowAuctionsAdmin } from './Etenders/index'
import { AuctionWinnerDeclartion, WinnerDeclartionForm } from './WinnerDeclartion/index'
import { Authorization } from './Authorization/index'
import { CustomerReciept } from "./CustomerReciept/index"
import { Report } from "./Report/index"

import { LoginPage, UploadPage, ViewFilePage, DataTable } from "./UploadFiles/index"


export {
    RefundCheck,
    Authorization,
    EditRoles,
    CustomMisReport,
    MISActiveReport,
    CreateDepartment,
    EditViewEmp,
    CreateEmployee,
    CreateRoles,
    WinnerDeclartionForm,
    AuctionWinnerDeclartion,
    ShowAuctionsAdmin,
    AdminDashboard,
    CreateAuction,
    AuctionRefund,
    GenerateRefund,
    TenderWinnerRefund,
    PaymentTable,
    RefundFiles,
    AdminPassKeys,
    OpenTenders,
    ClosedTenders,
    TenderCancelRefund,
    GenerateTenderCancelRefund,
    CustomerReciept,
    Report,
    LoginPage, UploadPage, ViewFilePage, DataTable
}